'use strict';

export default {
  searchInput: {
    placeholder: 'Rechercher...',
  },
};
